import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { getCities } from 'models/cities'; // Importing function to retrieve cities data
import { getTags } from 'models/tags'; // Importing function to retrieve tags data
import { getPositions } from 'models/positions'; // Importing function to retrieve positions data
import 'webix/photo'; // Importing Webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from Webix
import { devConfig } from '../../config/config'; // Importing development configuration
import { persons } from '../../models/persons'; // Importing persons model

/**
 * Class representing the Information Agent List View.
 * @extends JetView
 */
export default class InformationAgentListView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Get the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Get the current screen size configuration
        const screen = this.app.config.size;
        // Define available languages for selection
        const lenguages = [
            { id: 'ES', value: 'español (o castellano) (ES)' },
            { id: 'EN', value: 'English (EN)' },
        ];
        // Define the main layout configuration
        const main1 = {
            margin: 5, // Set margin for the layout
            minWidth: 265, // Set minimum width for the layout
            cols: [
                {
                    padding: 5, // Set padding for the column
                    rows: [
                        {
                            view: 'text', // Define a text input field
                            name: 'Id', // Name of the field
                            label: _('Número de usuario'), // Label for the field
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Número de usuario'), // Placeholder text
                            disabled: true, // Field is disabled
                        },
                        {
                            view: 'text', // Define a text input field
                            name: 'BalanceAssigned', // Name of the field
                            type: 'number', // Field type is number
                            label: _('Saldo Asignado'), // Label for the field
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Saldo Asignado'), // Placeholder text
                            disabled: true, // Field is disabled
                        },
                        {
                            view: 'text', // Define a text input field
                            name: 'Login', // Name of the field
                            label: _('Login para acceso'), // Label for the field
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Login para acceso'), // Placeholder text
                        },
                        {
                            view: 'text', // Define a text input field
                            name: 'BalanceAssigned', // Name of the field
                            label: _('Saldo de comisión'), // Label for the field
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Saldo de comisión'), // Placeholder text
                            disabled: true, // Field is disabled
                        },
                        {
                            view: 'text', // Define a text input field
                            name: 'LastIPaddress', // Name of the field
                            type: 'number', // Field type is number
                            label: _('Última dirección IP'), // Label for the field
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Última dirección IP'), // Placeholder text
                            disabled: true, // Field is disabled
                        },
                        {
                            view: 'text', // Define a text input field
                            name: 'LastModifiedUser', // Name of the field
                            label: _('Último usuario modif'), // Label for the field
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Último usuario modif'), // Placeholder text
                            disabled: true, // Field is disabled
                        },
                        {
                            view: 'richselect', // Define a rich select dropdown
                            name: 'Type', // Name of the field
                            label: _('Tipo'), // Label for the field
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [
                                // Options for the dropdown
                                { id: '0', value: _('Agente') }, // Option for 'Agent'
                                { id: '1', value: _('Afiliado') }, // Option for 'Affiliate'
                            ],
                            disabled: true, // Field is disabled
                        },
                        {
                            view: 'richselect', // Define a rich select dropdown
                            name: 'State', // Name of the field
                            localId: 'State:combo', // Local ID for the field
                            label: _('Estado'), // Label for the field
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [
                                // Options for the dropdown
                                { id: 'A', value: _('Activo') }, // Option for 'Active'
                                { id: 'I', value: _('Inactivo') }, // Option for 'Inactive'
                                { id: 'R', value: _('Retirado') }, // Option for 'Withdrawn'
                            ],
                        },
                        {
                            view: 'richselect', // Define a rich select dropdown
                            name: 'PreferredLanguage', // Name of the field
                            localId: 'PreferredLanguage:combo', // Local ID for the field
                            label: _('Idioma preferido:'), // Label for the field
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: lenguages, // Options for the dropdown from the languages array
                        },
                        {
                            view: 'text', // Define a text input field
                            name: 'Name', // Name of the field
                            label: _('Nombre del usuario'), // Label for the field
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Nombre del usuario'), // Placeholder text
                        },
                        {
                            view: 'richselect', // Define a rich select dropdown
                            name: 'CountryId', // Name of the field
                            id: 'country', // ID for the field
                            localId: 'Country:combo', // Local ID for the field
                            label: _('País'), // Label for the field
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [], // Options for the dropdown (empty for now)
                            disabled: true, // Field is disabled
                        },
                        {
                            view: 'richselect', // Define a rich select dropdown
                            name: 'CurrencyId', // Name of the field
                            id: 'currency', // ID for the field
                            localId: 'Currency:combo', // Local ID for the field
                            label: _('Moneda'), // Label for the field
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [], // Options for the dropdown (empty for now)
                            disabled: true, // Field is disabled
                        },
                        {
                            view: 'text', // Define a text input field
                            name: 'CreatedLocalDate', // Name of the field
                            label: _('Fecha de creación'), // Label for the field
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Fecha de creación'), // Placeholder text
                            disabled: true, // Field is disabled
                        },
                        {
                            view: 'text', // Define a text input field
                            name: 'LastLoginLocalDate', // Name of the field
                            label: _('Fecha última entrada'), // Label for the field
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Fecha última entrada'), // Placeholder text
                            disabled: true, // Field is disabled
                        },
                        {
                            view: 'text', // Define a text input field
                            name: 'LastDateModified', // Name of the field
                            label: _('Última Fecha modif'), // Label for the field
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Última Fecha modif'), // Placeholder text
                            disabled: true, // Field is disabled
                        },
                        {
                            view: 'textarea', // Define a textarea for multi-line input
                            name: 'Note', // Name of the field
                            label: _('Observación'), // Label for the field
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Observación'), // Placeholder text
                            disabled: false, // Field is enabled
                            height: 150, // Set height for the textarea
                        },
                    ],
                },
            ],
        };
        /**
         * Configuration options for the main layout.
         * @type {Object}
         * @property {number} margin - The margin around the main layout.
         * @property {number} minWidth - The minimum width of the layout.
         * @property {Array} cols - An array of column configurations.
         */
        const options_main = {
            margin: 5, // Margin around the main layout
            minWidth: 265, // Minimum width of the layout
            cols: [
                {
                    padding: 5, // Padding for the column
                    rows: [
                        {
                            rows: [
                                { view: 'label', label: _('Estado especial') }, // Label for special status
                                {
                                    id: 'SpecialStatus', // Unique identifier for the switch
                                    view: 'switch', // Switch component
                                    onLabel: _('Activo'), // Label when switch is on
                                    offLabel: _('Inactivo'), // Label when switch is off
                                },
                            ],
                        },
                        {
                            rows: [
                                { view: 'label', label: _('Pinagent') }, // Label for Pinagent
                                {
                                    id: 'Pinagent', // Unique identifier for the switch
                                    view: 'switch', // Switch component
                                    onLabel: _('Si'), // Label when switch is on
                                    offLabel: _('No'), // Label when switch is off
                                },
                            ],
                        },
                        {
                            rows: [
                                {
                                    view: 'label',
                                    label: _('Bloqueado para ventas'), // Label for sales lock status
                                },
                                {
                                    id: 'Lockedsales', // Unique identifier for the switch
                                    view: 'switch', // Switch component
                                    onLabel: _('Si'), // Label when switch is on
                                    offLabel: _('No'), // Label when switch is off
                                },
                            ],
                        },
                        {
                            rows: [
                                {
                                    view: 'label',
                                    label: _('Imprime recibo caja'), // Label for receipt printing option
                                },
                                {
                                    id: 'PrintReceiptBox', // Unique identifier for the switch
                                    view: 'switch', // Switch component
                                    onLabel: _('Si'), // Label when switch is on
                                    offLabel: _('No'), // Label when switch is off
                                },
                            ],
                        },
                        {
                            rows: [
                                { view: 'label', label: _('Permite recargas') }, // Label for recharge permission
                                {
                                    id: 'AllowsRecharges', // Unique identifier for the switch
                                    view: 'switch', // Switch component
                                    onLabel: _('Si'), // Label when switch is on
                                    offLabel: _('No'), // Label when switch is off
                                },
                            ],
                        },
                        {
                            rows: [
                                {
                                    view: 'label',
                                    label: _('Permite activar reg'), // Label for registration activation permission
                                },
                                {
                                    id: 'ActivateRegistration', // Unique identifier for the switch
                                    view: 'switch', // Switch component
                                    onLabel: _('Si'), // Label when switch is on
                                    offLabel: _('No'), // Label when switch is off
                                },
                            ],
                        },
                        {
                            rows: [
                                {
                                    view: 'label',
                                    label: _('Cálculo Individual'), // Label for individual calculation option
                                },
                                {
                                    id: 'IndividualCalculation', // Unique identifier for the switch
                                    view: 'switch', // Switch component
                                    onLabel: _('Si'), // Label when switch is on
                                    offLabel: _('No'), // Label when switch is off
                                },
                            ],
                        },
                        {
                            rows: [
                                {
                                    view: 'label',
                                    label: _('Arrastra Negativos'), // Label for dragging negatives option
                                },
                                {
                                    id: 'DragNegatives', // Unique identifier for the switch
                                    view: 'switch', // Switch component
                                    onLabel: _('Si'), // Label when switch is on
                                    offLabel: _('No'), // Label when switch is off
                                },
                            ],
                        },
                    ],
                },
            ],
        };
        /**
         * Configuration object for betshop details form.
         * @type {Object}
         * @property {number} margin - The margin around the form.
         * @property {number} minWidth - The minimum width of the form.
         * @property {Array} cols - Array of column configurations.
         */
        const betshop_details = {
            margin: 5, // Margin value in pixels
            minWidth: 250, // Minimum width in pixels
            cols: [
                {
                    padding: 5, // Padding value in pixels for the column
                    rows: [
                        {
                            view: 'text', // Type of input view
                            name: 'ContactName', // Name of the input field
                            label: _('Nombre del contacto'), // Label for the input field
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Nombre del contacto'), // Placeholder text
                        },
                        {
                            view: 'text',
                            name: 'Document',
                            type: 'number', // Input type is number
                            label: _('Número cédula'), // Label for the input field
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Numero cédula'), // Placeholder text
                        },
                        {
                            view: 'text',
                            name: 'Email',
                            label: _('Correo electrónico'), // Label for the input field
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Correo electrónico'), // Placeholder text
                        },
                        {
                            view: 'text',
                            name: 'Description',
                            label: _('Descripción'), // Label for the input field
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Descripción'), // Placeholder text
                        },
                        {
                            view: 'text',
                            name: 'Phone',
                            type: 'number', // Input type is number
                            label: _('Teléfono'), // Label for the input field
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Teléfono'), // Placeholder text
                        },
                        {
                            view: 'richselect', // Type of input view for a dropdown
                            name: 'Concessionaire', // Name of the input field
                            id: 'Concessionaire', // Unique identifier for the input
                            localId: 'Concessionaire:combo', // Local identifier for the component
                            label: _('Concesionario'), // Label for the input field
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [], // Options for the dropdown
                        },
                        {
                            view: 'richselect', // Type of input view for a dropdown
                            name: 'Subconcessionaire', // Name of the input field
                            id: 'Subconcessionaire', // Unique identifier for the input
                            localId: 'Subconcessionaire:combo', // Local identifier for the component
                            label: _('Subconcesionario'), // Label for the input field
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [], // Options for the dropdown
                        },
                        {
                            view: 'richselect', // Type of input view for a dropdown
                            name: 'RegionId', // Name of the input field
                            id: 'ProvinceRegion', // Unique identifier for the input
                            localId: 'ProvinceRegion:combo', // Local identifier for the component
                            label: _('Provincia/Región'), // Label for the input field
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [], // Options for the dropdown
                        },
                        {
                            view: 'richselect', // Type of input view for a dropdown
                            name: 'CityId', // Name of the input field
                            id: 'City', // Unique identifier for the input
                            localId: 'City:combo', // Local identifier for the component
                            label: _('Ciudad'), // Label for the input field
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [], // Options for the dropdown
                        },
                        {
                            view: 'text',
                            name: 'Address', // Name of the input field
                            label: _('Dirección'), // Label for the input field
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Dirección'), // Placeholder text
                        },
                        {
                            view: 'text',
                            name: 'District', // Name of the input field
                            label: _('Barrio'), // Label for the input field
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Barrio'), // Placeholder text
                        },
                        {
                            view: 'text',
                            name: 'IP',
                            type: 'number', // Input type is number
                            label: _('IP'), // Label for the input field
                            labelPosition: 'top', // Position of the label
                            placeholder: _('IP'), // Placeholder text
                        },
                    ],
                },
            ],
        };
        /**
         * Configuration object for the right-centered layout.
         * @type {Object}
         * @property {number} margin - The margin around the layout.
         * @property {number} padding - The padding inside the layout.
         * @property {Array<Object>} cols - Array of column configurations.
         */
        const center_right = {
            margin: 5, // Margin value for the layout
            padding: 5, // Padding value for the layout
            cols: [
                {
                    rows: [
                        // Array of row configurations within the column
                        {
                            view: 'text', // Type of view for the input field
                            name: 'DailyQuotaReloads', // Unique name for the input field
                            label: _('Limite diario de recargas'), // Label for the input field, translated
                            labelPosition: 'top', // Position of the label relative to the input field
                            placeholder: _('Limite diario de recargas'), // Placeholder text for the input field, translated
                        },
                        {
                            view: 'text', // Type of view for the input field
                            name: 'CommissionReloads', // Unique name for the input field
                            label: _('Comisión recargas'), // Label for the input field, translated
                            labelPosition: 'top', // Position of the label relative to the input field
                            placeholder: _('Comisión recargas'), // Placeholder text for the input field, translated
                        },
                        {
                            view: 'text', // Type of view for the input field
                            name: 'MinimumBet', // Unique name for the input field
                            label: _('Apuesta mínima'), // Label for the input field, translated
                            labelPosition: 'top', // Position of the label relative to the input field
                            placeholder: _('Apuesta mínima'), // Placeholder text for the input field, translated
                        },
                        {
                            view: 'text', // Type of view for the input field
                            name: 'DailyLimit', // Unique name for the input field
                            label: _('Límite diario'), // Label for the input field, translated
                            labelPosition: 'top', // Position of the label relative to the input field
                            placeholder: _('Límite diario'), // Placeholder text for the input field, translated
                        },
                    ],
                },
            ],
        };
        // Object representing the right section layout configuration
        const right = {
            margin: 5, // Margin around the right section
            rows: [], // Array to hold rows within the right section
        };

        // Object representing the upper section layout configuration
        const upper_section = {
            id: 'b5', // Unique identifier for the upper section
            rows: [
                // Array to hold rows within the upper section
                {
                    collapsed: true, // Indicates if the section is collapsed by default
                    multi: true, // Allows multiple items to be expanded
                    view: 'accordion', // Type of view for the section
                    css: 'betShop', // CSS class for styling
                    margin: 15, // Margin around the upper section
                    responsive: 'b5', // Responsive design identifier
                    cols: [
                        // Array to hold columns within the upper section
                        {
                            multi: true, // Allows multiple items to be expanded
                            view: 'accordion', // Type of view for the column
                            css: 'betShop', // CSS class for styling
                            collapsed: false, // Indicates if the column is collapsed by default
                            paddingY: 10, // Vertical padding for the column
                            type: 'clean', // Type of column layout
                            rows: [
                                // Array to hold rows within the column
                                {
                                    header: _('Datos Principales'), // Header title for the row
                                    body: {
                                        // Body configuration for the row
                                        padding: 10, // Padding inside the body
                                        rows: [
                                            // Array to hold rows within the body
                                            {
                                                margin: 10, // Margin around the column
                                                cols: [main1], // Columns to be displayed in this row
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                        {
                            multi: true, // Allows multiple items to be expanded
                            view: 'accordion', // Type of view for the column
                            css: 'betShop', // CSS class for styling
                            collapsed: false, // Indicates if the column is collapsed by default
                            paddingY: 10, // Vertical padding for the column
                            type: 'clean', // Type of column layout
                            rows: [
                                // Array to hold rows within the column
                                {
                                    header: _('Datos Agente'), // Header title for the row
                                    body: {
                                        // Body configuration for the row
                                        rows: [betshop_details], // Rows to be displayed in this body
                                    },
                                },
                            ],
                        },
                        {
                            multi: true, // Allows multiple items to be expanded
                            view: 'accordion', // Type of view for the column
                            css: 'betShop', // CSS class for styling
                            collapsed: false, // Indicates if the column is collapsed by default
                            paddingY: 10, // Vertical padding for the column
                            type: 'clean', // Type of column layout
                            rows: [
                                // Array to hold rows within the column
                                {
                                    header: _('Datos Configuración'), // Header title for the row
                                    body: {
                                        // Body configuration for the row
                                        padding: 10, // Padding inside the body
                                        rows: [
                                            // Array to hold rows within the body
                                            {
                                                margin: 10, // Margin around the column
                                                cols: [options_main], // Columns to be displayed in this row
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    ],
                },
            ],
        };
        const buttons = {
            /**
             * CSS class name for the button container.
             * @type {string}
             */
            css: 'betShop',

            /**
             * Array of column definitions for the button layout.
             * @type {Array<Object>}
             */
            cols: [
                {},
                {
                    /**
                     * Defines a button component.
                     * @type {Object}
                     */
                    view: 'button',

                    /**
                     * Unique identifier for the button.
                     * @type {string}
                     */
                    id: 'buttonSave',

                    /**
                     * Text displayed on the button, translated using the _ function.
                     * @type {string}
                     */
                    value: _('Guardar'),

                    /**
                     * Specifies the button type as a form button.
                     * @type {string}
                     */
                    type: 'form',

                    /**
                     * Automatically adjusts the button width to fit its content.
                     * @type {boolean}
                     */
                    autowidth: true,

                    /**
                     * Indicates whether the button is disabled initially.
                     * @type {boolean}
                     */
                    disabled: true,

                    /**
                     * Click event handler for the button.
                     * Validates the form and processes the data if valid.
                     * @returns {void}
                     */
                    click: () => {
                        // Validate the form before processing
                        if (this.getRoot().validate()) {
                            /**
                             * Retrieves the form values.
                             * @type {Object}
                             */
                            const newdata = this.getRoot().getValues();

                            /**
                             * Sets the SpecialStatus based on the value of the corresponding UI element.
                             * @type {string}
                             */
                            if ($$('SpecialStatus').getValue() == 1) {
                                newdata.SpecialStatus = 'A';
                            } else {
                                newdata.SpecialStatus = 'I';
                            }

                            /**
                             * Sets the Lockedsales based on the value of the corresponding UI element.
                             * @type {string}
                             */
                            if ($$('Lockedsales').getValue() == 1) {
                                newdata.Lockedsales = 'S';
                            } else {
                                newdata.Lockedsales = 'N';
                            }

                            /**
                             * Sets the Pinagent based on the value of the corresponding UI element.
                             * @type {string}
                             */
                            if ($$('Pinagent').getValue() == 1) {
                                newdata.Pinagent = 'S';
                            } else {
                                newdata.Pinagent = 'N';
                            }

                            /**
                             * Sets the PrintReceiptBox based on the value of the corresponding UI element.
                             * @type {string}
                             */
                            if ($$('PrintReceiptBox').getValue() == 1) {
                                newdata.PrintReceiptBox = 'S';
                            } else {
                                newdata.PrintReceiptBox = 'N';
                            }

                            /**
                             * Sets the AllowsRecharges based on the value of the corresponding UI element.
                             * @type {string}
                             */
                            if ($$('AllowsRecharges').getValue() == 1) {
                                newdata.AllowsRecharges = 'S';
                            } else {
                                newdata.AllowsRecharges = 'N';
                            }

                            /**
                             * Sets the ActivateRegistration based on the value of the corresponding UI element.
                             * @type {string}
                             */
                            if ($$('ActivateRegistration').getValue() == 1) {
                                newdata.ActivateRegistration = 'S';
                            } else {
                                newdata.ActivateRegistration = 'N';
                            }

                            /**
                             * Sets the IndividualCalculation based on the value of the corresponding UI element.
                             * @type {string}
                             */
                            if ($$('IndividualCalculation').getValue() == 1) {
                                newdata.IndividualCalculation = 'S';
                            } else {
                                newdata.IndividualCalculation = 'N';
                            }

                            /**
                             * Sets the DragNegatives based on the value of the corresponding UI element.
                             * @type {string}
                             */
                            if ($$('DragNegatives').getValue() == 1) {
                                newdata.DragNegatives = 'S';
                            } else {
                                newdata.DragNegatives = 'N';
                            }

                            /**
                             * Calls an event to update the agent with the new data.
                             * @param {string} 'Agent:update' - The event name.
                             * @param {Array<Object>} [newdata] - The new data to be sent.
                             */
                            this.app.callEvent('Agent:update', [newdata]);
                        } else {
                            /**
                             * Displays an error message if the form validation fails.
                             * @type {Object}
                             */
                            webix.message({
                                title: _('¡Mensaje!'),
                                type: 'alert-error',
                                text: _('Completa los campos...'),
                            });
                        }
                    },
                },
            ],
        };
        return {
            /**
             * Specifies the type of view for the component.
             * @type {string}
             */
            view: 'form',

            /**
             * Unique identifier for the form.
             * @type {string}
             */
            id: 'formId',

            /**
             * Enables vertical scrolling for the form.
             * @type {string}
             */
            scroll: 'y',

            /**
             * Array of components to be displayed in the form.
             * @type {Array}
             */
            rows: [buttons, upper_section],

            /**
             * Configuration for the elements within the form.
             * @type {Object}
             */
            elementsConfig: {
                /**
                 * Event handlers for the form elements.
                 * @type {Object}
                 */
                on: {
                    /**
                     * Function to be called when the form elements change.
                     * Validates the form using the specified form ID.
                     * @function
                     */
                    onChange: function () {
                        $$('formId').validate(); // Validate the form when changes occur
                    },
                },
            },
        };
    }

    /**
     * Initializes the view.
     * @param {Object} form - The form object to initialize.
     */
    init(form) {
        // Retrieve the localization service from the app
        const _ = this.app.getService('locale')._;
        // Initialize webix ready event
        webix.ready(function () {
            // Attach event to reload the page on orientation change
            webix.attachEvent('onRotate', function (orientation) {
                window.location.reload();
            });
        });
        // Store reference to 'this' for later use
        var vthis = this;
        // Listen for 'Agent:update' event
        this.on(this.app, 'Agent:update', (data) => {
            // Perform an AJAX POST request to update agent data
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json',
                })
                .post(devConfig.geturlApi() + 'Agent/UpdateAgent', data, {
                    // Handle error response
                    error: function (text, data, XmlHttpRequest) {
                        webix.message(_('Error'));
                    },
                    // Handle success response
                    success: function (text, data, XmlHttpRequest) {
                        var resp = JSON.parse(text);
                        // Check for errors in the response
                        if (resp.HasError) {
                            webix.message(_('Error'));
                        } else {
                            webix.message(_('Guardado'));
                            // Reload the page on successful update
                            window.location.reload();
                        }
                    },
                });
        });
        // Listen for 'formAgent:update' event
        this.on(this.app, 'formAgent:update', (id) => {
            // Perform an AJAX GET request to retrieve client data by ID
            webix.ajax().get(devConfig.geturlApi() + 'Client/GetClientSpById', 'id=' + id, {
                // Handle error response
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! ');
                },
                // Handle success response
                success: function (text, data, XmlHttpRequest) {
                    text = JSON.parse(text);
                    // Set values based on the retrieved data
                    if (text[0].SpecialStatus == 'A') {
                        $$('SpecialStatus').setValue(1);
                    } else {
                        $$('SpecialStatus').setValue(0);
                    }
                    if (text[0].Pinagent == 'S') {
                        $$('Pinagent').setValue(1);
                    } else {
                        $$('Pinagent').setValue(0);
                    }
                    if (text[0].Lockedsales == 'S') {
                        $$('Lockedsales').setValue(1);
                    } else {
                        $$('Lockedsales').setValue(0);
                    }
                    if (text[0].PrintReceiptBox == 'S') {
                        $$('PrintReceiptBox').setValue(1);
                    } else {
                        $$('PrintReceiptBox').setValue(0);
                    }
                    if (text[0].AllowsRecharges == 'S') {
                        $$('AllowsRecharges').setValue(1);
                    } else {
                        $$('AllowsRecharges').setValue(0);
                    }
                    if (text[0].ActivateRegistration == 'S') {
                        $$('ActivateRegistration').setValue(1);
                    } else {
                        $$('ActivateRegistration').setValue(0);
                    }
                    if (text[0].IndividualCalculation == 'S') {
                        $$('IndividualCalculation').setValue(1);
                    } else {
                        $$('IndividualCalculation').setValue(0);
                    }
                    if (text[0].DragNegatives == 'S') {
                        $$('DragNegatives').setValue(1);
                    } else {
                        $$('DragNegatives').setValue(0);
                    }
                    // Delay execution to allow UI updates
                    webix.delay(
                        function () {
                            // Trigger 'agent:updatedata' event with the retrieved data
                            vthis.app.callEvent('agent:updatedata', [text[0]]);
                            // Set country value
                            $$('country').setValue(text[0].CountryId);
                            webix.delay(
                                function () {
                                    // Set currency and region values
                                    $$('currency').setValue(text[0].CurrencyId);
                                    $$('ProvinceRegion').setValue(text[0].RegionId);
                                    webix.delay(
                                        function () {
                                            // Set city value
                                            $$('City').setValue(text[0].CityId);
                                        },
                                        '',
                                        '',
                                        1000,
                                    );
                                },
                                '',
                                '',
                                1000,
                            );
                        },
                        '',
                        '',
                        1000,
                    );
                },
            });
        });
        // Perform an AJAX POST request to get agent countries
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json',
            })
            .post(devConfig.geturlApi() + 'Agent/GetAgentCountries', '', {
                // Handle error response
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! ');
                },
                // Handle success response
                success: function (text, data, XmlHttpRequest) {
                    var data = JSON.parse(text.replace(/"Id"/g, '"id"').replace(/"Name"/g, '"value"'));
                    var optionsCountries = $$('country').getList();
                    // Clear existing country options
                    optionsCountries.clearAll();
                    // Parse new country data
                    optionsCountries.parse(data.Data);
                    // Perform an AJAX POST request to get agents
                    webix
                        .ajax()
                        .headers({
                            'Content-type': 'application/json',
                        })
                        .post(devConfig.geturlApi() + 'Agent/GetAgentsTwoLevels2', '', {
                            // Handle error response
                            error: function (text, data, XmlHttpRequest) {
                                webix.message('Error! ');
                            },
                            // Handle success response
                            success: function (text, data, XmlHttpRequest) {
                                var data = JSON.parse(text.replace(/"id"/g, '"id"').replace(/"Name"/g, '"value"'));
                                // Check if there are no children in the data
                                if (data.Data.Children == null) {
                                    $$('Concessionaire').hide();
                                    $$('Subconcessionaire').hide();
                                } else {
                                    var options = $$('Concessionaire').getList();
                                    // Add a default option for 'Ninguno'
                                    data.Data.Children.unshift({
                                        id: '0',
                                        value: _('Ninguno'),
                                    });
                                    // Clear and parse new concessionaire options
                                    options.clearAll();
                                    options.parse(data.Data.Children);
                                }
                                // Trigger 'formAgent:update' event
                                vthis.app.callEvent('formAgent:update', [vthis.getParam('user', true)]);
                            },
                        });
                },
            });
        // Listen for 'agent:updatedata' event to set form values
        this.on(this.app, 'agent:updatedata', (person) => {
            form.setValues(person);
            $$('buttonSave').enable();
        });
        // Listen for 'person:select' event to set form values
        this.on(this.app, 'person:select', (person) => form.setValues(person));
        // Attach change event to country dropdown
        $$('country').attachEvent('onChange', function (newv, oldv) {
            var optionscountries = this.getList().getItem(newv);
            // Check if the selected country has defined options
            if (optionscountries != undefined) {
                var optionscurrencies = $$('currency').getList();
                // Clear existing currency options
                optionscurrencies.clearAll();
                // Parse new currency data
                optionscurrencies.parse(optionscountries.currencies);
                var optionsProvinceRegions = $$('ProvinceRegion').getList();
                // Clear existing province/region options
                optionsProvinceRegions.clearAll();
                // Parse new province/region data
                optionsProvinceRegions.parse(optionscountries.departments);
            }
        });
        // Attach change event to province/region dropdown
        $$('ProvinceRegion').attachEvent('onChange', function (newv, oldv) {
            var optionsProvinceRegions = this.getList().getItem(newv);
            var optionsCity = $$('City').getList();
            // Clear existing city options
            optionsCity.clearAll();
            // Check if the selected province/region has defined cities
            if (optionsProvinceRegions != undefined) {
                optionsCity.parse(optionsProvinceRegions.cities);
            }
        });
        // Attach change event to concessionaire dropdown
        $$('Concessionaire').attachEvent('onChange', function (newv, oldv) {
            var optionsProvinceRegions = this.getList().getItem(newv);
            var optionsCity = $$('Subconcessionaire').getList();
            // Clear existing subconcessionaire options
            optionsCity.clearAll();
            // Check if the selected concessionaire has defined children
            if (optionsProvinceRegions != undefined) {
                optionsCity.parse(optionsProvinceRegions.Children);
            }
            // Clear subconcessionaire value if permission allows
            if (devConfig.getPermAction('clearSubconcessionaire', 'Add')) {
                $$('Subconcessionaire').setValue('');
            }
        });
    }

    /**
     * Retrieves and localizes combo options for positions, tags, and cities.
     * Updates the respective combo lists with localized values.
     */
    getLocalizedComboOptions() {
        const _ = this.app.getService('locale')._; // Localization function
        let p_options = webix.copy(getPositions()); // Copying positions data
        p_options.map((x) => (x.value = _(x.value))); // Localizing position values
        this.$$('position:combo').getPopup().getList().parse(p_options); // Parsing positions into combo

        let t_options = webix.copy(getTags()); // Copying tags data
        t_options.map((x) => (x.value = _(x.value))); // Localizing tag values
        this.$$('tags:combo').getPopup().getList().parse(t_options); // Parsing tags into combo

        let c_options = webix.copy(getCities()); // Copying cities data
        c_options.map((x) => (x.value = _(x.value))); // Localizing city values
        this.$$('cities:combo').getPopup().getList().parse(c_options); // Parsing cities into combo
    }
}

// FILE DOCUMENTED
